import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import PasswordInput from "../../components/PasswordInput/PasswordInput";
import ToastModal from "../../components/ToastModal/ToastModal";
import TopBarLogin from "../../components/TopBarLogin/TopBarLogin";

import { supabase } from "../../utils/supabaseClient";
import bcrypt from "bcryptjs";

import {
  Container,
  Panel,
  Header,
  Title,
  Ornament,
  OrnLine,
  OrnDiamond,
  Subtitle,
  Form,
  Label,
  Input,
  SubmitButton,
  InlineLink,
  MsgError,
  MsgSuccess,
  ResendBtn,
} from "./LoginPageStyles";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const topRef = useRef(null);

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showResend, setShowResend] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  useEffect(() => {
    if (location.state?.scrollTo === "top" && topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");
    setShowResend(false);

    const { data: users, error } = await supabase
      .from("user")
      .select("*")
      .eq("email", email);

    if (error || !users || users.length === 0) {
      setErrorMessage("Email sau parolă incorecte. Încearcă din nou.");
      return;
    }

    const user = users[0];

    if (!user.confirmed) {
      setErrorMessage(
        "Contul nu este confirmat. Verifică emailul pentru confirmare.",
      );
      setShowResend(true);
      return;
    }

    const match = await bcrypt.compare(password, user.parola);
    if (!match) {
      setErrorMessage("Email sau parolă incorecte. Încearcă din nou.");
      return;
    }

    localStorage.setItem(
      "user",
      JSON.stringify({
        id: user.id,
        nume: user.nume,
        prenume: user.prenume,
        email: user.email,
        role: user.role,
      }),
    );
    localStorage.setItem("userEmail", user.email);

    setSuccessMessage(`Bine ai revenit, ${user.prenume} ${user.nume}!`);

    setTimeout(() => {
      navigate("/");
    }, 900);
  };

  const handleResendEmail = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_GRAPHQL_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          query: `
            mutation ResendConfirmation($email: String!) {
              resendConfirmation(email: $email) { message }
            }
          `,
          variables: { email },
        }),
      });

      const result = await response.json();
      if (result.errors) {
        setToastMsg("A apărut o eroare. Încearcă din nou.");
      } else {
        setToastMsg(result.data.resendConfirmation.message);
        setShowResend(false);
      }
    } catch (err) {
      setToastMsg("Eroare la trimiterea emailului.");
    }
  };

  return (
    <>
      <TopBarLogin />
      <Container ref={topRef}>
        <Panel>
          <Header>
            <Title>Contul meu</Title>
            <Ornament aria-hidden="true">
              <OrnLine />
              <OrnDiamond />
              <OrnLine />
            </Ornament>
            <Subtitle>Conectează-te. Introdu mai jos datele contului.</Subtitle>
          </Header>

          <Form onSubmit={handleLogin}>
            <div>
              <Label>E-mail *</Label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>

            <div>
              <Label>Parolă *</Label>
              <PasswordInput
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <InlineLink>
                <Link to="/changepsw">Ai uitat parola?</Link>
              </InlineLink>
            </div>

            <SubmitButton type="submit">Autentificare</SubmitButton>

            {errorMessage && (
              <>
                <MsgError>{errorMessage}</MsgError>
                {showResend && (
                  <div style={{ textAlign: "center" }}>
                    <ResendBtn type="button" onClick={handleResendEmail}>
                      Trimite din nou emailul de confirmare
                    </ResendBtn>
                  </div>
                )}
              </>
            )}

            {successMessage && <MsgSuccess>{successMessage}</MsgSuccess>}
          </Form>
        </Panel>

        <ToastModal message={toastMsg} onClose={() => setToastMsg("")} />
      </Container>
    </>
  );
}
